// extracted by mini-css-extract-plugin
module.exports = {"textMessageBody":"TextMessagingStyles_textMessageBody__2p0Mt"};